import React from 'react'
import styled, { css } from 'styled-components'
import { Block } from '@mote/ui'
import {
  Control,
  Durations,
  PlayPauseButton,
  Scrubber
} from '../../shared/components'
import { useMotePlayer } from '../../shared/contexts/motePlayer.context'

export const ReplyPlayer = ({ replyIsMine }) => {
  const { play, pause, playing } = useMotePlayer()

  return (
    <Root layout='horizontal' align='center' gap={12}>
      <StyledPlayPauseButton
        size={48}
        data-testid={playing ? 'pause-button' : 'play-button'}
        aria-label={`${playing ? 'Pause' : 'Play'} (press k)`}
        isPlaying={playing}
        onClick={e => {
          e.stopPropagation()
          playing ? pause() : play()
        }}
        replyIsMine={replyIsMine}
      />

      <Block gap={6} spreadX>
        <StyledScrubber replyIsMine={replyIsMine} />
        <Durations
          divider='/'
          fontSize={12}
          color={replyIsMine ? '#ffffff' : '#232323'}
        />
      </Block>
    </Root>
  )
}

const Root = styled(Block)`
  position: relative;
`

const StyledScrubber = styled(Scrubber)`
  .range-slider__track {
    background-color: rgba(213, 212, 218, 0.5);
  }

  .range-slider__filled-track {
    background: linear-gradient(
      90deg,
      rgba(172, 10, 232, 0.2) 0%,
      #ac0ae8 100%
    );
    opacity: 0.8;
  }

  ${({ replyIsMine }) =>
    replyIsMine &&
    css`
      .range-slider__filled-track {
        background: linear-gradient(
          90deg,
          rgba(255, 255, 255, 0.3) 0%,
          #ffffff 100%
        );
      }

      .range-slider__thumb {
        background: #ffffff;

        &:focus,
        &[data-focus] {
          box-shadow: 0 0 0 3px rgba(101, 0, 138, 0.5);
        }
      }
    `};
`

const StyledPlayPauseButton = styled(PlayPauseButton)`
  background-color: #ffffff;

  ${({ replyIsMine }) =>
    replyIsMine &&
    css`
      &:focus {
        box-shadow: 0 0 0 3px rgba(101, 0, 138, 0.5);
      }
    `}
`
